import { AlertDescription, AlertIcon, AlertTitle, Box, Alert as ChakraAlert } from "@chakra-ui/react"

export default function Alert({ children, title, ...props }){
    return(
    <ChakraAlert borderRadius={6} fontSize={12} {...props}>
        <AlertIcon />
        <Box>
        { title && <AlertTitle children={title} /> }
        {children}
        </Box>
    </ChakraAlert>
    )
}